import { useState } from 'react';
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  message,
  ModalProps,
  Row,
} from '@sinohealth/butterfly-ui-components/lib';
import { useLoginSecurity } from '@/security/context';
import { removeToken } from '@/utils/cookies';
import { PasswordStrengthField } from '@/components/PasswordStrength';
import ConfirmModel from '@/components/Confirm';
import { getUserInfo, updateUserPassword } from '@/services/user';
import { validIsPasswordReg } from '@/utils/validate';
import { useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import style from './index.less';

const { Item } = Form;
interface PasswordModalProps extends ModalProps {}
function PasswordModal(props: PasswordModalProps) {
  const navigator = useNavigate();
  const { profile } = useLoginSecurity();
  const [saving, setSaving] = useState(false);
  const { data } = useSWR<any>('getUserInfo', getUserInfo);
  const { visible, onOk, ...other } = props;
  const [form] = Form.useForm();
  const newPassword = Form.useWatch('newPassword', form);
  const handleOk = async (e: any) => {
    form.submit();
  };
  const onFinish = async (values: any) => {
    if (saving) return;
    setSaving(true);
    try {
      await updateUserPassword({
        ...values,
        id: data?.userId || profile?.id,
      });
      await message.success('修改密码成功，请重新登录', 2);
    } catch {
      // API errors are displayed by the interceptor; retain the gate on failure.
      return;
    } finally {
      setSaving(false);
    }
    removeToken();
    navigator('/login', { replace: true });
    onOk && onOk(values);
  };
  const extra = (
    <span>
      忘记旧密码？
      <a
        onClick={() => {
          ConfirmModel({
            fun: 'warning',
            title: '确认退出当前账号？',
            node: '退出将转跳登录页，需重新登录才可访问系统',
            centered: true,
            // icon: <QuestionCircleTwoTone twoToneColor="#FFBF00" />,
            onOk: async () => {
              removeToken();
              navigator('/password');
            },
          });
        }}
      >
        退出登录，短信验证
      </a>
    </span>
  );
  return (
    // <Modal
    //   className={style.passwordModal}
    //   title="修改密码"
    //   width={560}
    //   visible={visible}
    //   {...other}
    //   onOk={handleOk}
    // >
    <div className={style.box}>
      <div className={style.boxTitle}>修改密码</div>
      {profile?.pwdNeedChange && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 24 }}
          message="安全提醒：您的账号仍在使用初始密码，请修改后继续使用系统。"
        />
      )}
      <Form
        form={form}
        style={{ width: '640px', maxWidth: '100%' }}
        onFinish={onFinish}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 16 }}
      >
        <Item
          label="旧密码"
          name="oldPassword"
          extra={extra}
          rules={[{ required: true, message: '请输入旧密码' }]}
        >
          <Input.Password placeholder="输入旧密码" style={{ width: '400px' }} />
        </Item>
        <Item
          label="新密码"
          name="newPassword"
          className={`${style.passwordField} ${newPassword ? style.passwordRulesOnly : ''}`}
          extra={<PasswordStrengthField name="newPassword" />}
          rules={[
            { required: true, message: '请输入密码' },
            {
              pattern: validIsPasswordReg,
              message: '',
            },
          ]}
        >
          <Input.Password placeholder="10-20位，须含字母、数字、符号" style={{ width: '400px' }} />
        </Item>
        <Item
          label="确认密码"
          name="confirmPassword"
          dependencies={['newPassword']}
          rules={[
            { required: true, message: '请确认新密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('两次密码不一致'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="确认新密码" style={{ width: '400px' }} />
        </Item>
        <Row>
          {/* <Col span={4} /> */}
          <Col span={20} style={{ textAlign: 'right', padding: '14px 54px 14px 14px' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={saving}
              disabled={!data?.userId && !profile?.id}
            >
              保存
            </Button>
          </Col>
        </Row>
        {/* <Item label="" style={{ textAlign: 'right', padding: '14px' }}> */}
        {/* <div style={{ textAlign: 'right', padding: '14px' }}>
          <Button type="primary" htmlType="submit">
            保存
          </Button>
        </div> */}

        {/* </Item> */}
      </Form>
    </div>
    // </Modal>
  );
}

export default PasswordModal;
